<template>
  <!--
      作者：kmdshop
      时间：2019-10-24
      描述：统计-会员统计-排行榜
  -->
  <div class="">
    <div class="common-form">排行榜</div>
      <div class="d-b-c">
        <div>
          <el-select v-model="form.role" placeholder="请选择角色" @change="handleChange">
            <el-option label="全部" value="0"></el-option>
            <!-- 确保 value 是字符串 -->
            <el-option v-for="(item, index) in role" :key="index" :label="item.label" :value="String(item.value)"></el-option>
          </el-select>
          <el-date-picker
            size="small"
            v-model="datePicker"
            type="daterange"
            align="right"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
      </div>
      <div class="echarts-container">
        <div id="barChart" style="width: 100%; height: 500px;"></div>
      </div>
    </div>
</template>

<script>
import UserApi from '@/api/user.js';
import StatisticsApi from '@/api/statistics.js';
import { formatDate } from '@/utils/DateTime.js'

export default {
  components: {},
  data() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
    
    return {
      dataList: {},
      role: [],
      form: {
        role: '0',  // 保持字符串类型
      },
      myChart: null,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      datePicker: [],
      loading: true
    };
  },
  
  watch: {
    // 添加 immediate: true 确保初始时也触发
    'form.role': {
      handler() {
        this.getData();
      },
      immediate: true
    },
    datePicker: {
      handler() {
        this.getData();
      },
      immediate: true
    }
  },
  
  created() {
    this.getRole();
  },
  
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initChart();
      }, 100);
    });
  },
  
  methods: {
    initChart() {
      if (this.myChart) {
        this.myChart.dispose();
      }
      
      const chartDom = document.getElementById('barChart');
      if (!chartDom) {
        console.error('找不到图表容器 #barChart');
        return;
      }
      
      this.myChart = this.$echarts.init(chartDom);
      
      const emptyOption = {
        title: {
          text: '加载中...',
          left: 'center',
          top: 'center'
        }
      };
      this.myChart.setOption(emptyOption);
      
      // 注释掉这行，因为watch会触发getData
      // this.getData();
    },
    
    changeDate() {
      // 添加日志确认事件触发
    },
    
    handleChange() {
      // 添加日志确认事件触发
    },
    
    getData() {
      // 添加防抖，避免频繁请求
      if (this.timer) {
        clearTimeout(this.timer);
      }
      
      this.timer = setTimeout(() => {
        this._getData();
      }, 300);
    },
    
    _getData() {
      const params = {
        role: this.form.role,
        startDate: this.datePicker ? this.datePicker[0] : '',
        endDate: this.datePicker ? this.datePicker[1] : ''
      };
      
      
      var self = this;
      this.loading = true;
      
      StatisticsApi.getInviteRanking(params, true)
        .then(res => {
          
          if (res.code && res.code === 1) {
            self.dataList = res.data || {};
            self.loading = false;
            self.renderChart();
          } else {
            console.error('API返回错误：', res.msg);
            self.dataList = {};
            self.loading = false;
            self.renderChart();
          }
        })
        .catch(error => {
          console.error('获取数据失败：', error);
          self.loading = false;
          self.renderChart();
        });
    },
    
    renderChart() {
      if (!this.myChart) {
        console.error('图表实例未初始化');
        return;
      }
      
      
      let xAxisData = []; // 用户名（底部显示）
      let seriesData = []; // 邀请人数（左侧显示）
      
      // 检查数据结构
      if (Array.isArray(this.dataList) && this.dataList.length > 0) {
        // 按邀请人数降序排序
        const sortedData = [...this.dataList].sort((a, b) => {
          const aInvite = parseInt(a.total_invite) || 0;
          const bInvite = parseInt(b.total_invite) || 0;
          return bInvite - aInvite;
        });
        
        // 只显示前10名，避免图表太拥挤
        const displayData = sortedData.slice(0, 10);
        
        // 提取用户名和邀请人数
        xAxisData = displayData.map(item => {
          // 使用 nickName 或 user_id 作为用户名
          let name = item.nickName || `用户${item.user_id}`;
          // // 如果用户名太长，截断
          // if (name && name.length > 8) {
          //   name = name.substring(0, 6) + '...';
          // }
          return name;
        });
        
        seriesData = displayData.map(item => parseInt(item.total_invite) || 0);
        
      } else if (this.dataList && typeof this.dataList === 'object') {
        
        // 处理对象格式的数据（如 {0: {...}, 1: {...}}）
        const dataArray = [];
        for (let key in this.dataList) {
          if (this.dataList.hasOwnProperty(key) && typeof this.dataList[key] === 'object') {
            dataArray.push(this.dataList[key]);
          }
        }
        
        if (dataArray.length > 0) {
          
          // 按邀请人数降序排序
          const sortedData = [...dataArray].sort((a, b) => {
            const aInvite = parseInt(a.total_invite) || 0;
            const bInvite = parseInt(b.total_invite) || 0;
            return bInvite - aInvite;
          });
          
          const displayData = sortedData.slice(0, 10);
          
          // 提取用户名和邀请人数
          xAxisData = displayData.map(item => {
            let name = item.nickName || `用户${item.user_id}`;
            if (name && name.length > 8) {
              name = name.substring(0, 6) + '...';
            }
            return name;
          });
          
          seriesData = displayData.map(item => parseInt(item.total_invite) || 0);
        }
      }
      
      // 确保数据不为空
      if (xAxisData.length === 0 || seriesData.length === 0) {
        const emptyOption = {
          title: {
            text: '暂无数据',
            subtext: '当前筛选条件下没有邀请记录',
            left: 'center',
            top: 'center',
            textStyle: {
              fontSize: 18,
              color: '#999'
            }
          }
        };
        
        this.myChart.setOption(emptyOption, true);
        this.myChart.resize();
        return;
      }
      
      // 创建tooltip所需的数据映射
      const tooltipData = {};
      let originalData = [];
      
      if (Array.isArray(this.dataList)) {
        originalData = [...this.dataList].sort((a, b) => {
          const aInvite = parseInt(a.total_invite) || 0;
          const bInvite = parseInt(b.total_invite) || 0;
          return bInvite - aInvite;
        }).slice(0, 20);
      } else if (this.dataList && typeof this.dataList === 'object') {
        // 如果是对象格式，转换为数组
        const dataArray = [];
        for (let key in this.dataList) {
          if (this.dataList.hasOwnProperty(key) && typeof this.dataList[key] === 'object') {
            dataArray.push(this.dataList[key]);
          }
        }
        originalData = [...dataArray].sort((a, b) => {
          const aInvite = parseInt(a.total_invite) || 0;
          const bInvite = parseInt(b.total_invite) || 0;
          return bInvite - aInvite;
        }).slice(0, 20);
      }
      
      // 创建tooltip格式化函数
      const tooltipFormatter = (params) => {
        const dataIndex = params[0].dataIndex;
        const user = originalData[dataIndex];
        
        if (!user) {
          return `${xAxisData[dataIndex]}<br/>邀请人数：${seriesData[dataIndex]}人`;
        }
        
        let html = `<div style="font-weight:bold;">${user.nickName || `用户${user.user_id}`}</div>`;
        html += `<div>邀请人数：<span style="color:#1890ff;font-weight:bold">${user.total_invite || 0}</span> 人</div>`;
        
        // 添加其他信息
        html += '<hr style="margin:5px 0;border:none;border-top:1px solid #eee">';
        html += '<div style="font-size:12px;color:#666;">';
        html += `用户ID：${user.user_id || '--'}<br>`;
        if (user.role_text) html += `角色：${user.role_text}<br>`;
        if (user.expend_money) html += `消费金额：¥${user.expend_money}<br>`;
        if (user.total_points) html += `积分：${user.total_points}<br>`;
        html += '</div>';
        
        return html;
      };
      
      const option = {
        title: {
          text: '',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        grid: {
          left: '0',
          right: '10%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: tooltipFormatter,
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          name: '用户',
          nameTextStyle: {
            fontWeight: 'bold'
          },
          axisLabel: {
            rotate: 45,
            fontSize: 12,
            interval: 0,
            color: '#666'
          },
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '邀请人数',
          nameTextStyle: {
            fontWeight: 'bold'
          },
          axisLabel: {
            formatter: '{value} 人'
          },
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#eee'
            }
          }
        },
        series: [{
          name: '邀请人数',
          type: 'bar',
          data: seriesData,
          itemStyle: {
            color: (params) => {
              const colors = [
                '#1890ff', '#52c41a', '#faad14', '#f5222d', '#722ed1',
                '#13c2c2', '#eb2f96', '#fa8c16', '#a0d911', '#2f54eb'
              ];
              return colors[params.dataIndex % colors.length];
            },
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: '50%',
          label: {
            show: true,
            position: 'top',
            formatter: '{c}人',
            fontSize: 12,
            fontWeight: 'bold'
          }
        }],
        dataZoom: [{
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 100
        }]
      };
      
      this.myChart.setOption(option, true); // 使用 true 来替换之前的配置
      this.myChart.resize();
      
    },
    
    getRole() {
      let self = this;
      UserApi.getRole({}, true)
        .then(data => {
          if (data.code && data.code === 1) {
            self.role = data.data || [];
          }
        })
        .catch(error => {
          console.error('获取角色失败：', error);
        });
    }
  },
  
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose();
    }
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
};
</script>

<style scoped="scoped">
.member-rangking {
  width: 100%;
}

.echarts-container {
  width: 100%;
  height: 500px;
  margin-top: 20px;
  padding: 10px;
}

#barChart {
  width: 100%;
  height: 100%;
  min-height: 500px;
}

.d-b-c {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
}

.common-form.mt30 {
  margin-top: 30px;
  margin-bottom: 20px;
  padding-left: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/user/part/Ranking.vue